import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from './Notification.service';

/**
 * Interceptor chặn các request ghi dữ liệu (POST/PUT/PATCH/DELETE) khi chạy trên mobile APK.
 * GET vẫn được phép để xem / tra cứu.
 */
@Injectable()
export class MobileActionBlockInterceptor implements HttpInterceptor {
  // TẠM THỜI disable toàn bộ cơ chế chặn để debug login trên mobile.
  // TODO: bật lại sau khi xác định xong luồng gọi API ổn định.
  constructor(private notification: NotificationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req);
  }
}

